import { Component, EventEmitter, Output, Input } from "@angular/core";
import { NgxImageCompressService } from "ngx-image-compress";

@Component({
  selector: "app-image-upload",
  templateUrl: "./image-upload.component.html",
})
export class ImageUploadComponent {
  @Input() label = "Imagen";

  @Output() imageChange = new EventEmitter<File | null>();

  private _preview: string | ArrayBuffer | null = null;

  @Input()
  set preview(value: string | ArrayBuffer | null) {
    this._preview = value;
  }

  get preview(): string | ArrayBuffer | null {
    return this._preview;
  }

  private _file: File | null = null;

  @Input()
  set file(value: File | null) {
    this._file = value;

    if (!value) {
      this._preview = null;
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      this._preview = reader.result;
    };

    reader.readAsDataURL(value);
  }

  get file(): File | null {
    return this._file;
  }

  constructor(private imageCompress: NgxImageCompressService) {}

  async onFileSelected(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    const base64 = await this.fileToBase64(file);

    const compressed = await this.imageCompress.compressFile(
      base64 as string,
      -1,
      50, // calidad
      50, // ratio tamaño
    );

    this.preview = compressed;

    const compressedFile = this.base64ToFile(compressed, file.name);

    this.imageChange.emit(compressedFile);
  }

  onDrop(event: DragEvent) {
    event.preventDefault();

    const file = event.dataTransfer?.files[0];
    if (!file) return;

    this.setFile(file);
  }

  allowDrop(event: DragEvent) {
    event.preventDefault();
  }

  setFile(file: File) {
    if (!file.type.startsWith("image/")) return;

    this._file = file;

    const reader = new FileReader();

    reader.onload = () => {
      this._preview = reader.result;
    };

    reader.readAsDataURL(file);

    this.imageChange.emit(file);
  }

  remove() {
    this.preview = null;
    this.file = null;

    this.imageChange.emit(null);
  }
  fileToBase64(file: File) {
    return new Promise((resolve) => {
      const reader = new FileReader();

      reader.onload = () => resolve(reader.result);

      reader.readAsDataURL(file);
    });
  }
  base64ToFile(dataUrl: string, filename: string): File {
    const arr = dataUrl.split(",");
    const mime = arr[0].match(/:(.*?);/)![1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }
}
